<gpd-multi-step-popup
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  i18n-title="@@addContact"
  title="Add Contact"
  [steps]="steps"
  i18n-finishText="@@add"
  finishText="Add"
  width="56vw"
  height="auto"
  [maxHeight]="'82vh'"
  (onCancelClicked)="close()"
  (onNextClicked)="onNextClicked()"
  (onFinishClicked)="onFinishClicked()"
>
</gpd-multi-step-popup>

<ng-template #selectStepTemplate>
  <div class="select-step">
    <div class="popup-tab-bar">
      <button
        class="pnb-tab"
        [class.pnb-tab--active]="activeTab === 'company'"
        (click)="setActiveTab('company')"
        i18n="@@companies"
      >
        Companies
      </button>
      <button
        class="pnb-tab"
        [class.pnb-tab--active]="activeTab === 'person'"
        (click)="setActiveTab('person')"
        i18n="@@persons"
      >
        Persons
      </button>
      <button
        *ngIf="societiesEnabled"
        class="pnb-tab"
        [class.pnb-tab--active]="activeTab === 'society'"
        (click)="setActiveTab('society')"
        i18n="@@gesellschaften"
      >Gesellschaften</button>
    </div>

    <div [hidden]="activeTab !== 'company'" class="grid-tab">
      <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [value]="searchText.company"
        (onValueChanged)="onSearchInput('company', $event.value)" [width]="300"
        i18n-placeholder="@@companySearchPlaceholder" placeholder="Search name or city …"></dx-text-box>
      <dx-data-grid
        #companyGrid
        (onInitialized)="companyGridInstance = $event.component"
        [dataSource]="companies"
        keyExpr="id"
        class="gpd-datagrid gpd-datagrid-slim"
        [(selectedRowKeys)]="selectedCompanyKeys"
        (onSelectionChanged)="onCompanySelectionChanged($event)"
        (onRowClick)="onCompanyRowClick($event)"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        height="auto"
        [width]="'100%'"
        [scrolling]="{ mode: 'standard', useNative: true }"
        [paging]="{ enabled: true, pageSize: 10 }"
        [pager]="{ visible: false }"
        (onContentReady)="getCompanyGridPageInfo()"
        (onOptionChanged)="onCompanyGridOptionChanged($event)"
        [noDataText]="noDataText('company')"
      >
        <dxo-selection mode="multiple" showCheckBoxesMode="always" [allowSelectAll]="false"></dxo-selection>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxi-column dataField="displayName" i18n-caption="@@name" caption="Name"></dxi-column>
        <!-- Server order while a search is active, see applySearch. -->
        <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="companyRank"></dxi-column>
        <dxi-column
          dataField="tags"
          i18n-caption="@@tags"
          caption="Tags"
          [allowSorting]="false"
          [allowFiltering]="true"
          [allowHeaderFiltering]="true"
          cellTemplate="tagTemplate"
          [calculateFilterExpression]="filterTags"
        >
          <dxo-lookup [dataSource]="contactTags" valueExpr="id" displayExpr="title"></dxo-lookup>
          <div *dxTemplate="let item of 'tagTemplate'" class="contact-tag-container">
            <gpd-pill
              *ngFor="let tag of item.data.tags"
              [text]="getTag(tag)"
              backgroundColor="var(--color-secondary)"
              color="var(--color-primary)"
            ></gpd-pill>
          </div>
        </dxi-column>
      </dx-data-grid>
      <app-gpd-pagination
        [currentPage]="companyGridCurrentPage"
        [totalPages]="companyGridTotalPages"
        [itemsPerPage]="companyGridTotalItems === 0 ? 0 : (companyGridShowingTo - companyGridShowingFrom + 1)"
        [totalItems]="companyGridTotalItems"
        (onPageChange)="onCompanyGridPageChange($event)"
      ></app-gpd-pagination>
    </div>

    <div [hidden]="activeTab !== 'person'" class="grid-tab">
      <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [value]="searchText.person"
        (onValueChanged)="onSearchInput('person', $event.value)" [width]="300"
        i18n-placeholder="@@contactSearchPlaceholder" placeholder="Search name or e-mail …"></dx-text-box>
      <dx-data-grid
        #personGrid
        (onInitialized)="personGridInstance = $event.component"
        [dataSource]="persons"
        keyExpr="id"
        class="gpd-datagrid gpd-datagrid-slim"
        [(selectedRowKeys)]="selectedPersonKeys"
        (onSelectionChanged)="onPersonSelectionChanged($event)"
        (onRowClick)="onPersonRowClick($event)"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        height="auto"
        [width]="'100%'"
        [scrolling]="{ mode: 'standard', useNative: true }"
        [paging]="{ enabled: true, pageSize: 10 }"
        [pager]="{ visible: false }"
        (onContentReady)="getPersonGridPageInfo()"
        (onOptionChanged)="onPersonGridOptionChanged($event)"
        [noDataText]="noDataText('person')"
      >
        <dxo-selection mode="multiple" showCheckBoxesMode="always" [allowSelectAll]="false"></dxo-selection>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxi-column
          caption="Name"
          i18n-caption="@@name"
          [calculateCellValue]="personName"
          [allowSorting]="true"
        ></dxi-column>
        <!-- Server order while a search is active, see applySearch. -->
        <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="personRank"></dxi-column>
        <dxi-column
          dataField="tags"
          i18n-caption="@@tags"
          caption="Tags"
          [allowSorting]="false"
          [allowFiltering]="true"
          [allowHeaderFiltering]="true"
          cellTemplate="tagTemplate"
          [calculateFilterExpression]="filterTags"
        >
          <dxo-lookup [dataSource]="contactTags" valueExpr="id" displayExpr="title"></dxo-lookup>
          <div *dxTemplate="let item of 'tagTemplate'" class="contact-tag-container">
            <gpd-pill
              *ngFor="let tag of item.data.tags"
              [text]="getTag(tag)"
              backgroundColor="var(--color-secondary)"
              color="var(--color-primary)"
            ></gpd-pill>
          </div>
        </dxi-column>
      </dx-data-grid>
      <app-gpd-pagination
        [currentPage]="personGridCurrentPage"
        [totalPages]="personGridTotalPages"
        [itemsPerPage]="personGridTotalItems === 0 ? 0 : (personGridShowingTo - personGridShowingFrom + 1)"
        [totalItems]="personGridTotalItems"
        (onPageChange)="onPersonGridPageChange($event)"
      ></app-gpd-pagination>
    </div>

    <div *ngIf="societiesEnabled" [hidden]="activeTab !== 'society'" class="grid-tab">
      <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [value]="searchText.society"
        (onValueChanged)="onSearchInput('society', $event.value)" [width]="300"
        i18n-placeholder="@@companySearchPlaceholder" placeholder="Search name or city …"></dx-text-box>
      <dx-data-grid
        (onInitialized)="societyGridInstance = $event.component"
        [dataSource]="societies"
        keyExpr="id"
        class="gpd-datagrid gpd-datagrid-slim"
        [(selectedRowKeys)]="selectedSocietyKeys"
        (onSelectionChanged)="onSocietySelectionChanged($event)"
        (onRowClick)="onSocietyRowClick($event)"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        height="auto"
        [width]="'100%'"
        [scrolling]="{ mode: 'standard', useNative: true }"
        [paging]="{ enabled: true, pageSize: 10 }"
        [pager]="{ visible: false }"
        (onContentReady)="getSocietyGridPageInfo()"
        (onOptionChanged)="onSocietyGridOptionChanged($event)"
        [noDataText]="noDataText('society')"
      >
        <dxo-selection mode="multiple" showCheckBoxesMode="always" [allowSelectAll]="false"></dxo-selection>
        <dxi-column dataField="displayName" i18n-caption="@@name" caption="Name"></dxi-column>
        <!-- Server order while a search is active, see applySearch. -->
        <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="societyRank"></dxi-column>
      </dx-data-grid>
      <app-gpd-pagination
        [currentPage]="societyGridCurrentPage"
        [totalPages]="societyGridTotalPages"
        [itemsPerPage]="societyGridTotalItems === 0 ? 0 : (societyGridShowingTo - societyGridShowingFrom + 1)"
        [totalItems]="societyGridTotalItems"
        (onPageChange)="onSocietyGridPageChange($event)"
      ></app-gpd-pagination>
    </div>

    <div class="hidden-validator">
      <dx-text-box [(value)]="selectionValidatorValue">
        <dx-validator>
          <dxi-validation-rule
            type="required"
            i18n-message="@@selectAtLeastOneContact"
            message="Please select at least one contact"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
  </div>
</ng-template>


<ng-template #roleStepTemplate>
  <div class="role-step">
    <div class="role-row" *ngFor="let contact of selectedContacts">
      <label class="role-label">
        <span i18n="@@roleForContact">Role for {{ contact.displayName }}</span>
        <span *ngIf="contact.contactType !== 'society'" class="role-label__required">*</span>
      </label>
      <!-- A Gesellschaft is linked like on its own page: its role is always "Gesellschaft". -->
      <span *ngIf="contact.contactType === 'society'; else roleSelect" class="role-fixed">{{ societyRole }}</span>
      <ng-template #roleSelect>
        <gpd-role-select [(value)]="contact.role" (roleCommitted)="onRoleCommitted()"></gpd-role-select>
      </ng-template>
    </div>
  </div>
</ng-template>

<app-contacts-popup
  [visible]="addPopupVisible"
  [contactType]="addPopupType"
  [companies]="companies"
  [persons]="persons"
  [showRole]="true"
  (onContactAdded)="onNewContactAdded($event)"
  (onContactSelected)="onExistingSelectedFromPopup($event)"
  (onHiding)="addPopupVisible = false"
></app-contacts-popup>
